import * as React from 'react';

import * as styles from './styles.css';
import { FillApplicationButton } from '../stickyButtons/FillApplicationButton';
import { useSelector } from 'react-redux';
import { selectCalculatorErrors, selectMarkedListItems } from '../../selectors/landing';
import { EFillApplicationStickyButtonType } from '../stickyButtons/FillApplicationButton/types';
import { useIsDesktop } from '../../hooks/common';
import { ETestIds } from '../../constants/testIds';
import sanitize from 'sanitize-html';
import { SeoMarkedList } from '../../components/SeoMarkedList';
import { DefaultSeoText } from './components/DefaultSeoText';
import { useSanitizedRichText } from './utils';
import cn from 'clsx';

export interface IInformationalSeoBlockProps {
  offersLength: number;
}

export const InformationalSeoBlock: React.FC<IInformationalSeoBlockProps> = ({ offersLength }) => {
  const isDesktop = useIsDesktop();
  const calculatorErrors = useSelector(selectCalculatorErrors);
  const isMasterButtonShows = isDesktop && offersLength > 0 && calculatorErrors.length === 0;
  const seoTextItems = useSelector(selectMarkedListItems);
  const sanitizedRichText = useSanitizedRichText();
  const isRichTextAvailable = sanitizedRichText;
  const sanitizedItems = React.useMemo(
    () =>
      seoTextItems.map(item => ({
        ...item,
        title: sanitize(item.title),
        content: sanitize(item.content),
      })),
    [seoTextItems],
  );

  /* oxlint-disable react/no-danger */
  const renderRichTextBlock = () =>
    isRichTextAvailable ? (
      <div
        className={cn(styles['border-wrapper'], styles['mb16'])}
        data-testid={ETestIds.SeoRichText}
        dangerouslySetInnerHTML={{ __html: sanitizedRichText }}
      />
    ) : null;

  if (sanitizedItems.length !== 0) {
    return (
      <div className={styles['root']} data-testid={ETestIds.SeoMarkedList}>
        {isRichTextAvailable && renderRichTextBlock()}
        <SeoMarkedList items={sanitizedItems} />
      </div>
    );
  }

  return (
    <div className={styles['root']} data-testid={ETestIds.InformationalSeo}>
      {isRichTextAvailable ? renderRichTextBlock() : <DefaultSeoText />}
      {isMasterButtonShows && <FillApplicationButton currentButtonType={EFillApplicationStickyButtonType.BOTTOM} />}
    </div>
  );
};
